export default "__VITE_ASSET__DWsCPIlI__"